import { call, put, select, takeEvery } from "redux-saga/effects";
import { fetchCVApp, fetchedCVApp, types } from "../actions";
import { fetchCVApps } from "../../api/CVAppsServiceManager";

const activeSession = (state) => state.sessionReducer.activeSession;

function* CVAppSaga() {
  yield takeEvery(types.FETCH_CV_APP, getCVApps);
}

function* getCVApps() {
  try {
    const session = yield select(activeSession);
    const cvApps = yield call(fetchCVApps, session.activeSession);
    yield put(fetchedCVApp(cvApps));
  } catch (error) {
    console.log("Error while getting CV Apps -> " + error);
  }
}

export default CVAppSaga;